import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hideable" ]

  showTargets() {
    console.log('hhhhh')
    this.hideableTargets.forEach(el => {
      el.hidden = false
    });
  }

}